import { Box, Card, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import TrendingDownIcon from '@mui/icons-material/TrendingDown'
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt'
import { Sidebar } from './sidebar'
import { LineComponent } from './line.component'
import Co2Icon from '@mui/icons-material/Co2'
import WaterDropIcon from '@mui/icons-material/WaterDrop'
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt'

export const Kpis = ({ width, kpis }) => {
    const [energyKpi, setEnergyKpi] = useState({})
    const [waterKpi, setWaterKpi] = useState({})
    const [carbonKpi, setCarbonKpi] = useState({})

    useEffect(() => {
        // let kpis = [
        //     {
        //         set: (val) => setEnergyKpi(val),
        //         type: 'energy',
        //         value: 0,
        //         last_year_value: 0,
        //         series: [],
        //         last_year_series: [],
        //     },
        //     {
        //         set: (val) => setWaterKpi(val),
        //         type: 'water',
        //         value: 0,
        //         last_year_value: 0,
        //         series: [],
        //         last_year_series: [],
        //     },
        // ]
        // let total_sq = sites?.map((el) => el?.surface)?.reduce((acc, curr) => acc + curr, 0)
        // let total_night = 0
        // sites?.map((site) => {
        //     kpis?.map((kpi) => {
        //         let series = site?.series
        //             ?.find((s) => s.type == kpi?.type)
        //             ?.data?.filter((d) => d?.date?.includes(year))
        //         if (series?.length) {
        //             kpi.value += series?.reduce((acc, curr) => acc + curr?.value, 0)
        //             if (kpi?.series?.length == 0) {
        //                 kpi.series = series
        //             } else {
        //                 kpi.series = kpi.series.map((s, i) => {
        //                     return {
        //                         ...s,
        //                         value: s.value + series[i].value,
        //                     }
        //                 })
        //             }
        //         }
        //         let last_year_series = site?.series
        //             ?.find((s) => s.type == kpi?.type)
        //             ?.data?.filter((d) => d?.date?.includes(year - 1))
        //         if (last_year_series?.length) {
        //             kpi.last_year_value += last_year_series?.reduce((acc, curr) => acc + curr?.value, 0)
        //             if (kpi?.last_year_series?.length == 0) {
        //                 kpi.last_year_series = last_year_series
        //             } else {
        //                 kpi.last_year_series = kpi.last_year_series.map((s, i) => {
        //                     return {
        //                         ...s,
        //                         value: s.value + last_year_series[i].value,
        //                     }
        //                 })
        //             }
        //         }
        //     })

        //     let night_series = site?.series
        //         ?.find((s) => s.subType === 'GUEST_NIGHTS')
        //         ?.data?.filter((d) => d?.month?.includes(year))
        //     total_night += night_series.reduce((acc, curr) => acc + curr?.value, 0)
        // })
        console.log('kpis ###', kpis)

        let energy_kpi = kpis?.find((kpi) => kpi?.type === 'energy')
        let water_kpi = kpis?.find((kpi) => kpi?.type === 'water')
        let carbon_kpi = kpis?.find((kpi) => kpi?.subType === 'co2')
        setEnergyKpi(energy_kpi)
        setWaterKpi(water_kpi)
        setCarbonKpi(carbon_kpi)
    }, [kpis])
    return (
        <Grid container spacing={2}>
            {[
                {
                    name: 'Energie',
                    value: Math.floor(energyKpi?.value),
                    value2: Math.floor(energyKpi?.valuePerNight),
                    unit: 'kWhef/m2',
                    unit2: 'kWhef/nuit',
                    icon: <ElectricBoltIcon style={{ maxWidth: 15 }} />,
                    percentage: energyKpi?.percentage,
                    series: energyKpi?.series,
                    last_year_series: energyKpi?.last_year_series,
                    description:
                        'Le terme “kWhef/m²” (kilowattheures d’énergie finale par mètre carré) est une unité de mesure utilisée pour quantifier la consommation énergétique d’un bâtiment par rapport à sa surface. Il indique combien de kilowattheures d’énergie finale sont consommés par mètre carré de surface sur une période donnée, généralement une année. L’énergie finale représente l’énergie réellement utilisée par le bâtiment, incluant toutes les sources d’énergie comme l’électricité, le gaz, le chauffage, etc.',
                },
                {
                    name: 'Carbone',
                    value: Math.floor(carbonKpi?.value),
                    value2: Math.floor(carbonKpi?.valuePerNight),
                    unit: 'kgeqCO2/m2 ',
                    unit2: 'kgeqCO2/nuit',
                    icon: <Co2Icon />,
                    percentage: carbonKpi?.percentage,
                    series: carbonKpi?.series,
                    last_year_series: carbonKpi?.last_year_series,
                    description:
                        'Le terme “kgeqCO2/m²” (kilogrammes équivalent CO2 par mètre carré) est une unité de mesure utilisée pour quantifier l’impact environnemental en termes d’émissions de gaz à effet de serre d’un bâtiment ou d’une activité par rapport à sa surface. Il indique combien de kilogrammes de dioxyde de carbone (CO2) et d’autres gaz à effet de serre, exprimés en équivalents CO2, sont émis par mètre carré de surface sur une période donnée, généralement une année.',
                },
                {
                    name: 'Eau',
                    value: waterKpi?.value?.toFixed(2),
                    value2: waterKpi?.valuePerNight?.toFixed(2),
                    unit: 'm3/m2',
                    unit2: 'm3/nuit',
                    icon: <WaterDropIcon style={{ maxWidth: 15 }} />,
                    percentage: waterKpi?.percentage,
                    series: waterKpi?.series,
                    last_year_series: waterKpi?.last_year_series,
                    description:
                        'Le terme “m3/m²” (mètres cubes par mètre carré) est une unité de mesure utilisée pour quantifier la consommation d’eau d’un bâtiment par rapport à sa surface. Il indique combien de mètres cubes d’eau sont consommés par mètre carré de surface sur une période donnée, généralement une année. Cette unité de mesure est utilisée pour évaluer l’efficacité de la gestion de l’eau dans un bâtiment et pour identifier les sources de gaspillage et les possibilités d’économie.',
                },
                // {
                //     name: 'Conso.',
                //     value: Math.floor(Math.random() * 100),
                //     unit: 'kWh',
                // },
            ].map((item, index) => {
                return (
                    <Grid item md={width} key={index}>
                        <KpiItem {...item} title={item?.name} />
                    </Grid>
                )
            })}
        </Grid>
    )
}

const KpiItem = ({ title, value, unit, value2, unit2, icon, percentage, series, last_year_series, description }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false)
    const up = percentage > 0

    const handleOpenSidebar = () => {
        setIsSidebarOpen(true)
    }

    const handleCloseSidebar = () => {
        setIsSidebarOpen(false)
    }
    const bottomHeight = 40
    return (
        <Card style={{ position: 'relative', paddingBottom: bottomHeight - 10 }}>
            <Box p={2}>
                <div
                    style={{
                        fontSize: 12,
                        fontWeight: 'bold',
                        color: '#212121',
                        letterSpacing: 2,
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    {title?.toUpperCase()}
                </div>
                <div
                    style={{
                        fontSize: 50,
                        fontWeight: 600,
                        color: '#424242',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        padding: 10,
                        alignItems: 'center',
                    }}
                >
                    {value}
                    <div style={{ fontSize: 12, marginLeft: 5, color: '#757575' }}>{unit}</div>
                </div>
            </Box>
            <div
                style={{
                    ...styles.stats,
                    background: up ? '#e8f5e9' : '#fce4ec',
                    color: up ? '#4caf50' : '#f44336',
                    cursor: 'pointer',
                }}
                onClick={handleOpenSidebar}
            >
                {up ? <TrendingUpIcon fontSize="22" /> : <TrendingDownIcon fontSize="22" />}
                <div style={{ marginLeft: 4 }}> {Math.floor(percentage)}%</div>
            </div>
            <div
                style={{
                    position: 'absolute',
                    background: '#f5f5f5',
                    bottom: 0,
                    width: '100%',
                    left: 0,
                    color: '#616161',
                    padding: 5,
                    fontSize: 12,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: bottomHeight,
                    // cursor: 'pointer',
                }}
            >
                <div style={{ marginRight: 5 }}>{icon}</div>
                {value2} {unit2}
                {/* Jan. - Jui. 2024
                <ArrowRightAltIcon /> */}
            </div>
            {isSidebarOpen ? (
                <Sidebar isOpen={isSidebarOpen} onClose={handleCloseSidebar}>
                    <div>
                        <h3>{`${title} (${unit})`}</h3>
                        <br />
                        <LineComponent
                            series={[
                                {
                                    data: series,
                                    color: '#40c4ff',
                                    name: series?.[0]?.date?.split('-')[0],
                                },
                                {
                                    data: last_year_series,
                                    color: '#757575',
                                    name: last_year_series?.[0]?.date?.split('-')[0],
                                },
                            ]}
                        />

                        <p>{description}</p>
                    </div>
                </Sidebar>
            ) : null}
        </Card>
    )
}

const styles = {
    stats: {
        position: 'absolute',
        top: 8,
        right: 8,
        borderRadius: 4,
        display: 'flex',
        fontSize: 14,
        alignItems: 'center',
        padding: 2,
    },
}
